import {
  AccountBalanceRounded,
  Chat,
  Favorite,
  HomeRounded,
  Settings,
  SummarizeRounded,
} from "@mui/icons-material";
import "./App.css";
import HEADER from "./components/header";
import MENU_CONTAINER from "./components/menu_container";
import React, { useEffect, useState } from "react";
import BANNER_NAME from "./components/banner_name";
import SUB_MENU_CONTAINER from "./components/subMenu_container";
import MENU_CARD from "./components/menu_card";
import { MenuItems, Items } from "./data/data";
import ITEM_CARD from "./components/item_card";
import DEBIT_CARD from "./components/debit_card";
import CART_ITEM from "./components/cart_item";
import { useStateValue } from "./redux/state_provider";

function App() {
  const [Menu_selected, setMenu_selected] = useState("buger01");
  const [{ cart, total }] = useStateValue();
  useEffect(() => {
    const menu_li = document.querySelectorAll("#menu li");
    console.log(menu_li);

    function set_menu_active() {
      menu_li.forEach((n) => n.classList.remove("active"));
      this.classList.add("active");
    }

    menu_li.forEach((n) => n.addEventListener("click", set_menu_active));
  }, [Menu_selected]);
  console.log(total)
  return (
    <div className="App">
      <HEADER />
      <main>
        {/* Main container */}
        <div className="main_container">
          <div className="banner">
            <BANNER_NAME name={"Jr Delivery"} discount={"20"} link={"#"} />
          </div>

          {/* Dish container */}
          <div className="dish_container">
            <div className="menu_card">
              <SUB_MENU_CONTAINER name={"Best seller"} />
            </div>
            <div className="row_container">
              {MenuItems.map((item, key) => (
                <div key={key} onClick={() => setMenu_selected(item.itemId)}>
                  <MENU_CARD name={item.name} img_src={item.imgSrc} />
                </div>
              ))}
            </div>
            <div className="dish_item_container">
              {Items.filter((item) => item.itemId.includes(Menu_selected)).map(
                (product, key) => (
                  <ITEM_CARD
                    itemId={product.id}
                    name={product.name}
                    price={product.price}
                    imgSrc={product.imgSrc}
                  />
                )
              )}
            </div>
          </div>
        </div>

        {/* Rigth menu */}
        <div className={`right_menu active`}>
          <div className="debit_container">
            <div className="debit_card">
              <DEBIT_CARD />
            </div>
          </div>

          <div className="cart_checkOut_container">
            <div className="cart_container">
              <SUB_MENU_CONTAINER name={"Carts Items"} />

              <div className="cart_items">
                {cart &&
                  cart.map((item) => (
                    <CART_ITEM
                      itemId={item.id}
                      name={item.name}
                      imgSrc={item.imgSrc}
                      price={item.price}
                    />
                  ))}
              </div>
            </div>

            <div className="total_section">
              <h3>Total</h3>
              <p>
                <span>$</span>
                {total}
              </p>
            </div>

            <button className="but_checkOut">Check out</button>
          </div>
        </div>

        <div className="cart_checkout_container"></div>
      </main>

      <div className="bottom_menu">
        <ul id="menu">
          <MENU_CONTAINER link={"#"} icon={<HomeRounded />} is_home={true} />
          <MENU_CONTAINER link={"#"} icon={<Chat />} />
          <MENU_CONTAINER link={"#"} icon={<AccountBalanceRounded />} />
          <MENU_CONTAINER link={"#"} icon={<Favorite />} />
          <MENU_CONTAINER link={"#"} icon={<SummarizeRounded />} />
          <MENU_CONTAINER link={"#"} icon={<Settings />} />

          <div className="indicator"></div>
        </ul>
      </div>
    </div>
  );
}

export default App;
